import BreadCrumb from "Common/BreadCrumb";
import ProductDetail from "./ProductDetail/productDetail";
import UserDetail from "./UserDetail/userDetail";
import ConfirmOrder from "./ConfirmOrder/confirmOrder";
import { useState } from "react";
import { OrderProvider, useOrderContext } from "../hooks/useGenerateOrder";

export interface AddressFormValues {
  firstname: string;
  lastname: string;
  companyname: string;
  country: string;
  address: string;
  city: string;
  state: string;
  Zipcode: string;
  Phone: string;
  Email: string;
}

const GenerateOrder = () => {
  return (
    <OrderProvider>
      <GenerateOrderContent />
    </OrderProvider>
  );
};

const GenerateOrderContent = () => {
  const { generateOrderValue } = useOrderContext();
  return (
    <div>
      <BreadCrumb title="Generate Order" pageTitle="Jewellery" />
      <form>
        <UserDetail />
        <ProductDetail />
        <ConfirmOrder />
        <div className="flex pb-5 justify-end">
          <button
            type="submit"
            onClick={(e) => {
              e.preventDefault();
              generateOrderValue.handleSubmit();
            }}
            className="h-[35px] px-4 whitespace-nowrap bg-custom-500 text-white rounded hover:bg-custom-600"
          >
            Generate Order
          </button>
        </div>
      </form>
    </div>
  );
};

export default GenerateOrder;
